// src/config/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyArOWy3QPyQgf2x7HsqZIOEc0w2M7zzbbU",
  authDomain: "anveshana-4d897.firebaseapp.com",
  projectId: "anveshana-4d897",
  storageBucket: "anveshana-4d897.firebasestorage.app", 
  messagingSenderId: "180010124992",
  appId: "1:180010124992:web:cfbce92463ab980168cf25",
  measurementId: "G-VWWYH7SXJ7"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const storage = getStorage(app);
const db = getFirestore(app);

export { auth, storage, db };